import { RouteObject } from 'react-router-dom';
import { AdminProfileManagementView } from './views/AdminProfileManagementView';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';

export const profileManagementRoutes: RouteObject[] = [
    {
        path: '/admin/profile-management',
        element: <AdminProfileManagementView />,
        errorElement: <ErrorBoundary />,
    }
];
